export const CREATE_USER_GROUP_REQUEST = 'CREATE_USER_GROUP_REQUEST';

export const CREATE_USER_GROUP_SUCCESS = 'CREATE_USER_GROUP_SUCCESS';

export const CREATE_USER_GROUP_FAILURE = 'CREATE_USER_GROUP_FAILURE';

export const GET_USERS_GROUPS_REQUEST = 'GET_USERS_GROUPS_REQUEST';

export const GET_USERS_GROUPS_SUCCESS = 'GET_USERS_GROUPS_SUCCESS';

export const GET_USERS_GROUPS_FAILURE = 'GET_USERS_GROUPS_FAILURE';

export const GET_USER_GROUP_REQUEST = 'GET_USER_GROUP_REQUEST';

export const GET_USER_GROUP_SUCCESS = 'GET_USER_GROUP_SUCCESS';

export const GET_USER_GROUP_FAILURE = 'GET_USER_GROUP_FAILURE';

export const CLEAN_USERS_GROUPS = 'CLEAN_USERS_GROUPS';

export const CLEAN_USER_GROUP = 'CLEAN_USER_GROUP';

export const SET_TOTAL_USERS_GROUPS = 'SET_TOTAL_USERS_GROUPS';

export const DELETE_USER_GROUP_REQUEST = 'DELETE_USER_GROUP_REQUEST';

export const DELETE_USER_GROUP_SUCCESS = 'DELETE_USER_GROUP_SUCCESS';

export const DELETE_USER_GROUP_FAILURE = 'DELETE_USER_GROUP_FAILURE';

export const UPDATE_USER_GROUP_REQUEST = 'UPDATE_USER_GROUP_REQUEST';

export const UPDATE_USER_GROUP_SUCCESS = 'UPDATE_USER_GROUP_SUCCESS';

export const UPDATE_USER_GROUP_FAILURE = 'UPDATE_USER_GROUP_FAILURE';

export const SEARCH_MEMBERS_REQUEST = 'SEARCH_MEMBERS_REQUEST';

export const SEARCH_MEMBERS_SUCCESS = 'SEARCH_MEMBERS_SUCCESS';

export const SEARCH_MEMBERS_FAILURE = 'SEARCH_MEMBERS_FAILURE';

export const SET_TOTAL_MEMBER_SUGGESTIONS = 'SET_TOTAL_MEMBER_SUGGESTIONS';

export const ADD_MEMBER = 'ADD_MEMBER';

export const DELETE_MEMBER = 'DELETE_MEMBER';

export const DELETE_ALL_MEMBERS = 'DELETE_ALL_MEMBERS';

export const GROUP_GENERAL_INFORMATION_READY = 'GROUP_GENERAL_INFORMATION_READY';

export const GROUP_EXPRESS_CONFIGURATION_READY = 'GROUP_EXPRESS_CONFIGURATION_READY';

export const GROUP_USERS_CONFIGURATION_READY = 'GROUP_USERS_CONFIGURATION_READY';

export const GET_MUSIC_ON_HOLD_REQUEST = 'GET_MUSIC_ON_HOLD_REQUEST';

export const GET_MUSIC_ON_HOLD_SUCCESS = 'GET_MUSIC_ON_HOLD_SUCCESS';

export const GET_MUSIC_ON_HOLD_FAILURE = 'GET_MUSIC_ON_HOLD_FAILURE';

export const SET_MEMBERS = 'SET_MEMBERS';

export const SEARCH_DEFAULT_EXTENSION_REQUEST = 'SEARCH_DEFAULT_EXTENSION_REQUEST';

export const SEARCH_DEFAULT_EXTENSION_SUCCESS = 'SEARCH_DEFAULT_EXTENSION_SUCCESS';

export const SEARCH_DEFAULT_EXTENSION_FAILURE = 'SEARCH_DEFAULT_EXTENSION_FAILURE';

export const SET_TOTAL_DEFAULT_EXTENSION = 'SET_TOTAL_DEFAULT_EXTENSION';

export const SET_DEFAULT_EXTENSION = 'SET_DEFAULT_EXTENSION';
